import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SKIP_ERROR_TOAST } from '../../interceptors/http-context-tokens';

@Injectable({ providedIn: 'root' })
export class FileFetchService {
    constructor(private http: HttpClient) {}

    public getFile(url: string): Observable<any> {
        return this.http.get(url, { responseType: 'blob', context: new HttpContext().set(SKIP_ERROR_TOAST, true) });
    }
}
